// 藥櫃詳細設定


<template lang="pug">
div.detail-layout(v-if="rowData.parent_system !== null")
  h5.text-center 請在母系統設定
div.detail-layout(v-else)
  div.row
    div.col-3
      h6 系統設定
      hr
      div.form-group
        label 系統名稱
        input.form-control(type="text" v-model="systemName")
      div.form-group
        label 所屬區域
        select.form-control(v-model="areaId")
          option(:value="item.value" v-for="item in area") {{ item.label }}
      div.form-group
        label 管理者
        select.form-control(v-model="adminId")
          option(:value="item.value" v-for="item in user") {{ item.label }}
    
    div.col-3
      h6 其他設定
      hr
      div.form-group
        label 藥物即期提醒時間(天)
        input.form-control(type="number" v-model="settings.alert_outdated_day")
      div.form-group
        label 前台自動登出(分)
        input.form-control(type="number" v-model="settings.app_login_timeout")
      div.form-group
        div.switch-wrapper
          div.switch
            input(id="switch-original-cmpn" type="checkbox" v-model="settings.return_to_original_cmpn")
            label.slider(for="switch-original-cmpn" :class="{ 'slider-on': settings.return_to_original_cmpn }")
          span.switch-title 退回原藥盒
        div.switch-wrapper
          div.switch
            input(id="switch-check-amount" type="checkbox" v-model="settings.check_amount_first")
            label.slider(for="switch-check-amount" :class="{ 'slider-on': settings.check_amount_first }")
          span.switch-title 動作前確認藥物
        div.switch-wrapper(v-if="settings.type === 'nursing'")
          div.switch
            input(id="switch-fetch-and-return-empty" type="checkbox" v-model="settings.fetch_return_empty_same_time")
            label.slider(for="switch-fetch-and-return-empty" :class="{ 'slider-on': settings.fetch_return_empty_same_time }")
          span.switch-title 取藥時同時退回藥瓶
    div.col-3
      h6 退藥理由
      hr
      table.table
        thead.thead-light
          tr 
            th.w-75 理由
            th 動作
        tbody
          tr(v-for="reason, ind in returnReason")
            th(style="vertical-align: middle")
              span {{reason}}
            th 
              button.btn.btn-sm.btn-danger(@click="deleteReason(ind)") 刪除
      button.btn.btn-sm.btn-info.mb-2(@click="createReason = !createReason") 新增退藥理由
      transition(name="slide-fade")
        div.create-form(v-if="createReason")
          div.form-inline
            input.form-control.mr-1(type="text" v-model="reason" placeholder="輸入欲新增理由")
            button.btn.btn-primary.btn-sm(@click="addReason") 新增
    div.col-3(v-if="rowData.settings.mode === 'aeth'")
      h6 排程設定
      hr
      div.switch-wrapper.mb-2
        div.switch
          input(id="switch-shift" type="checkbox" v-model="settings.shift_system_status")
          label.slider(for="switch-shift" :class="{ 'slider-on': settings.shift_system_status }")
        span.switch-title 使用班表系統
      div.mb-2
        router-link.btn.btn-sm.btn-info(:to="{ name: 'ShiftArrange' }" v-if="settings.shift_system_status") 檢視班表設定
    
      div
        router-link.btn.btn-sm.btn-info(:to="{ name: 'ScheduleList' }") 檢視手術排程
      
      
  hr      
  button.btn.btn-primary.float-right.mb-2(@click="save") 儲存設定
</template>

<script>
export default {
  name: 'ADCDetail',
  data() {
    return {
      area: [],
      department: [],
      user: [],
      adminId: null,
      areaId: 0,
      systemName: '',
      alert_outdated_day: 0,
      return_to_original_cmpn: false,
      settings: null,
      createReason: false,
      reason: '',
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
    // 退藥理由是用';'串在一起存在db裡
    returnReason() {
      const reasons = [];
      this.rowData.settings.return_reason.split(';').forEach((reason) => {
        reasons.push(reason);
      });
      return reasons;
    },
  },
  methods: {
    // 取得所有區域位置
    getArea() {
      return this.instance.get('/api/area/')
      .then((res) => {
        res.data.forEach((data) => {
          this.area.push({
            label: data.name,
            value: data.id,
          });
        });
      });
    },
    // 取得所有部門
    getDepartment() {
      return this.instance.get('/api/department/')
      .then((res) => {
        res.data.forEach((data) => {
          this.department.push({
            label: data.name,
            value: data.id,
          });
        });
      });
    },
    // 取得所有使用者
    getUser() {
      return this.instance.get('/api/user/')
      .then((res) => {
        res.data.results.forEach((data) => {
          this.user.push({
            label: data.username,
            value: data.id,
          });
        });
      });
    },
    // 儲存設定
    saveSetting() {
      return this.instance.patch(`/api/general-setting/${this.settings.id}/`, this.settings)
      .then((res) => {
        console.log(res);
      });
    },
    // 新增退藥理由
    async addReason() {
      const reasons = this.returnReason.join(';');
      console.log(this.returnReason, reasons);
      this.instance.patch(`/api/general-setting/${this.rowData.settings.id}/`, {
        return_reason: reasons.concat(`;${this.reason}`),
      })
      .then(() => {
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '新增成功',
        });
        this.createReason = false;
        this.$parent.refresh();
      });
    },
    // 刪除退藥理由
    async deleteReason(ind) {
      console.log(this.returnReason.splice(ind, 1));
      this.instance.patch(`/api/general-setting/${this.rowData.settings.id}/`, {
        return_reason: this.returnReason.join(';'),
      })
      .then(() => {
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '刪除成功',
        });
        this.$parent.refresh();
      });
    },
    // 儲存整個系統相關設定
    save() {
      this.instance.patch(`/api/system/${this.rowData.id}/`, {
        admin: this.adminId,
        area: this.areaId,
        name: this.systemName,
      })
      .then(async (res) => {
        console.log(res);
        await this.saveSetting();
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功',
        });
        this.$parent.refresh();
      })
      .catch(() => {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '請確認設定欄位皆已填妥資料',
        });
      });
    },
  },
  created() {
    this.getArea();
    this.getDepartment();
    this.getUser();
    if (this.rowData.admin !== null) this.adminId = this.rowData.admin.id;
    if (this.rowData.area !== null) this.areaId = this.rowData.area.id;
    this.systemName = this.rowData.name;
    this.settings = this.rowData.settings;
  },
};
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// ADCDetail.vue?5eac3a5b